export default {
  product: {
    new: 'New element',
    data: 'Description',
    add: 'Add',
    addAndSelect: 'Add and select'
  },
  productsTable: {
    modifyAndUpdate: 'Edit item data and click "Update item" to save changes',
    saveNew: 'Save as new element',
    create: 'Create',
    update: 'Update',
    createAndSelect: 'Create and select',
    updateAndSelect: 'Update and select',
    undo: 'Undo the changes',
    select: 'Select',
    noResults: 'No results',
    vendorCode: 'Vendor Code',
    description: 'Description',
    price: 'Price'
  },
  searchCatalog: {
    catalog: 'Catalogue',
    products: 'Products/Services',
    search: 'Search in the catalog',
    showing: 'Showing',
    vendorCode: 'Vendor Code',
    description: 'Description',
    price: 'Price',
    more: 'Show more',
    newElement: 'New element',
    addSelected: 'Add selected',
    deleteTitle: 'Delete selected products',
    deleteConfirm: 'Are you sure you want to delete the selected elements?'
  },
  catalogView: {
    deleteTitle: 'Summary of selected elements to delete',
    success: 'The products were successfully deleted.'
  }
}
